export default __webpack_public_path__ + "static/media/apple@2x.2e50bccf.jpg";